import SvgIcon from '@mui/material/SvgIcon';
import IconButton from '@mui/material/IconButton';

// ----------------------------------------------------------------------

export function MenuButton({ sx, ...other }) {
  return (
    <IconButton sx={[...(Array.isArray(sx) ? sx : [sx])]} {...other}>
      <SvgIcon>
        <path
          opacity="0.3"
          d="M15.8 4.5H5.2q-1.6.1-1.7 1.3.2 1 1.7 1.2h10.6q1.6-.1 1.7-1.2-.2-1.2-1.7-1.3"
          fill="currentColor"
        />
        <path
          d="M18.8 10.8H8.2q-1.6 0-1.7 1.2.2 1.2 1.7 1.3h10.6q1.6-.1 1.7-1.3-.2-1.1-1.7-1.2m-3 6.2H5.2q-1.6.1-1.7 1.3.2 1 1.7 1.2h10.6q1.6-.2 1.7-1.2-.2-1.2-1.7-1.3"
          fill="currentColor"
        />
      </SvgIcon>
    </IconButton>
  );
}
